import Food from '@components/offer/models/Food';
import { Box, Divider, Grid, Typography } from '@mui/material';
import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import React, { Fragment } from 'react';
import FoodPriceListItem from './FoodPriceListItem';
import FoodPrice from '@components/offer/models/FoodPrice';
import { getSizeName } from '@components/offer/helpers/foodPriceHelper';

interface FoodPriceListProps {
    food: Food
}

const FoodPriceList: React.FC<FoodPriceListProps> = observer(({ food }) => {
    const { foodPrices } = food;

    return (
        <Grid mt={0.8}>
            <Box display={"flex"} gap={3} alignItems={"flex-end"} height={29.69}>
                {_.map(food.foodPrices, (foodPrice, index) => (
                    <Fragment key={foodPrice.id}>
                        <Box>
                            <FoodPriceListItem foodPrice={foodPrice} />
                            <Typography
                                variant='caption'
                                color={"GrayText"}
                                lineHeight={0}>
                                {getSizeName(foodPrice)}
                            </Typography>
                        </Box>
                        {(index + 1) !== foodPrices.length && <Divider flexItem orientation='vertical' />}
                    </Fragment>
                ))}
            </Box>
        </Grid>
    )
})

export default FoodPriceList;